import Pagination, { PaginationProps } from 'antd/lib/pagination';
import React from 'react';
import ArrowLeftOutlined from '@ant-design/icons/lib/icons/ArrowLeftOutlined';
import ArrowRightOutlined from '@ant-design/icons/lib/icons/ArrowRightOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';
import {
  SearchFormValues,
  SEARCH_FORM_NAME,
  ELITE_SEARCH_FORM_NAME,
  REFUGEE_SEARCH_FORM_NAME,
} from 'components/search/search.logic';
import {
  getEliteOfferSearchResults,
  getOfferSearchResults,
  getRefugeeOfferSearchResults,
} from 'logic/store/offer/offer.selectors';
import { offerSlice } from 'logic/store/offer/offer.slice';
import {
  EXPLICIT_ELITE_OFFERS_PAGE_SIZE,
  OFFERS_PAGE_SIZE,
} from 'logic/store/offer/search-offer/search-offer.const';

const renderPaginatinItem: PaginationProps['itemRender'] = (page, type, originalElement) => {
  switch (type) {
    case 'prev':
      return (
        <a>
          <ArrowLeftOutlined />
        </a>
      );
    case 'next':
      return (
        <a>
          <ArrowRightOutlined />
        </a>
      );
    default:
      return originalElement;
  }
};

export const SearchItemListPagination: React.FC = () => {
  const dispatch = useDispatch();
  const formValues: SearchFormValues = useSelector(getFormValues(SEARCH_FORM_NAME)) || {};
  const { page = 1 } = formValues;
  const offers = useSelector(getOfferSearchResults);
  const totalPages = (offers?.totalCount || 0) / OFFERS_PAGE_SIZE;
  const shouldShowPagination = totalPages > 1;

  const handleOnChange: PaginationProps['onChange'] = (page) =>
    dispatch(
      offerSlice.actions.navigateToSearchResults({
        formValues: { ...formValues, page },
      })
    );

  return shouldShowPagination ? (
    <Pagination
      current={page}
      total={offers?.totalCount}
      pageSize={OFFERS_PAGE_SIZE}
      itemRender={renderPaginatinItem}
      showSizeChanger={false}
      onChange={handleOnChange}
      style={{ display: 'flex', justifyContent: 'center' }}
    />
  ) : null;
};

export const SearchEliteItemListPagination: React.FC = () => {
  const dispatch = useDispatch();
  const formValues: SearchFormValues = useSelector(getFormValues(ELITE_SEARCH_FORM_NAME)) || {};
  const { page = 1 } = formValues;
  const eliteOffers = useSelector(getEliteOfferSearchResults);
  const totalPages = (eliteOffers?.totalCount || 0) / EXPLICIT_ELITE_OFFERS_PAGE_SIZE;
  const shouldShowPagination = totalPages > 1;

  const handleOnChange: PaginationProps['onChange'] = (page) =>
    dispatch(
      offerSlice.actions.navigateToEliteSearchResults({
        formValues: { ...formValues, page },
      })
    );

  return shouldShowPagination ? (
    <Pagination
      current={page}
      total={eliteOffers?.totalCount}
      pageSize={EXPLICIT_ELITE_OFFERS_PAGE_SIZE}
      itemRender={renderPaginatinItem}
      showSizeChanger={false}
      onChange={handleOnChange}
      style={{ display: 'flex', justifyContent: 'center' }}
    />
  ) : null;
};

export const SearchRefugeeItemListPagination: React.FC = () => {
  const dispatch = useDispatch();
  const formValues: SearchFormValues = useSelector(getFormValues(REFUGEE_SEARCH_FORM_NAME)) || {};
  const { page = 1 } = formValues;
  const offers = useSelector(getRefugeeOfferSearchResults);
  const totalPages = (offers?.totalCount || 0) / OFFERS_PAGE_SIZE;
  const shouldShowPagination = totalPages > 1;

  const handleOnChange: PaginationProps['onChange'] = (page) => {
    if (formValues.city) {
      dispatch(
        offerSlice.actions.navigateToRefugeeLocalSearchResults({
          formValues: { ...formValues, page },
        })
      );
    } else {
      dispatch(
        offerSlice.actions.navigateToRefugeeOnlineSearchResults({
          formValues: { ...formValues, page },
        })
      );
    }
  };

  return shouldShowPagination ? (
    <Pagination
      current={page}
      total={offers?.totalCount}
      pageSize={OFFERS_PAGE_SIZE}
      itemRender={renderPaginatinItem}
      showSizeChanger={false}
      onChange={handleOnChange}
      style={{ display: 'flex', justifyContent: 'center' }}
    />
  ) : null;
};
